/**
 * SER VIVO — Quiz "Encuentra tu protocolo"
 * Las preguntas de objetivo suman puntos ponderados.
 * Edad y sexo personalizan el contexto sin alterar por sí solos la ruta sugerida.
 */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-sv-quiz]').forEach(function (quiz) {
    var steps = Array.prototype.slice.call(quiz.querySelectorAll('[data-sv-step]'));
    var resultBlocks = Array.prototype.slice.call(quiz.querySelectorAll('[data-sv-result]'));
    var fallback = quiz.querySelector('[data-sv-result-fallback]');
    var progressBar = quiz.querySelector('[data-sv-progress]');
    var scores = {};
    var goalOrder = [];
    var context = {};
    var contextLabels = {};
    var currentStep = 0;
    var isTransitioning = false;

    function updateCounters() {
      steps.forEach(function (step, index) {
        var counter = step.querySelector('[data-sv-counter]');
        if (counter) counter.textContent = 'Paso ' + (index + 1) + ' de ' + steps.length;
      });
    }

    function showStep(index) {
      steps.forEach(function (step, stepIndex) {
        step.classList.toggle('is-active', stepIndex === index);
      });

      if (progressBar) {
        var pct = steps.length ? Math.round((index / steps.length) * 100) : 0;
        progressBar.style.width = Math.min(100, pct) + '%';
      }
    }

    function getWinner() {
      var rankedGoals = Object.keys(scores).sort(function (goalA, goalB) {
        var scoreDifference = scores[goalB] - scores[goalA];
        if (scoreDifference !== 0) return scoreDifference;
        return goalOrder.indexOf(goalA) - goalOrder.indexOf(goalB);
      });

      return rankedGoals.length ? rankedGoals[0] : null;
    }

    function showResult() {
      var winner = getWinner();
      var activeResult = null;

      steps.forEach(function (step) { step.classList.remove('is-active'); });
      resultBlocks.forEach(function (block) {
        var isWinner = block.getAttribute('data-sv-result') === winner;
        block.classList.toggle('is-active', isWinner);
        if (isWinner) activeResult = block;
      });

      if (progressBar) progressBar.style.width = '100%';
      if (fallback) fallback.classList.toggle('is-active', !activeResult);

      if (activeResult) {
        var summary = activeResult.querySelector('[data-sv-context-summary]');
        var labels = [];
        if (contextLabels.age && context.age !== 'general') labels.push(contextLabels.age);
        if (contextLabels.sex && context.sex !== 'general') labels.push(contextLabels.sex);

        if (summary) {
          summary.textContent = labels.length ? 'Tu guía se adaptará a: ' + labels.join(' · ') + '.' : 'Prepararemos una guía general para tu rutina.';
        }

        quiz.dispatchEvent(new CustomEvent('sv:protocol-recommended', {
          bubbles: true,
          detail: { protocol: winner }
        }));
      }

      isTransitioning = false;
    }

    function pickOption(button) {
      if (isTransitioning) return;
      isTransitioning = true;

      var step = button.closest('[data-sv-step]');
      var questionType = step.getAttribute('data-question-type') || 'goal';
      var value = button.getAttribute('data-value') || '';
      var weight = parseInt(step.getAttribute('data-weight'), 10) || 1;

      step.querySelectorAll('.sv-quiz__option').forEach(function (option) {
        option.classList.toggle('is-selected', option === button);
      });

      if (questionType === 'goal' && value) {
        scores[value] = (scores[value] || 0) + weight;
        if (goalOrder.indexOf(value) === -1) goalOrder.push(value);
      } else if (value) {
        context[questionType] = value;
        contextLabels[questionType] = button.textContent.trim();
      }

      window.setTimeout(function () {
        if (currentStep < steps.length - 1) {
          currentStep += 1;
          showStep(currentStep);
          isTransitioning = false;
        } else {
          showResult();
        }
      }, 220);
    }

    function restartQuiz() {
      scores = {};
      goalOrder = [];
      context = {};
      contextLabels = {};
      currentStep = 0;
      isTransitioning = false;

      quiz.querySelectorAll('.sv-quiz__option').forEach(function (option) {
        option.classList.remove('is-selected');
      });
      resultBlocks.forEach(function (block) { block.classList.remove('is-active'); });
      if (fallback) fallback.classList.remove('is-active');
      showStep(0);
    }

    quiz.addEventListener('click', function (event) {
      var option = event.target.closest('.sv-quiz__option');
      var restart = event.target.closest('[data-sv-restart]');

      if (option && quiz.contains(option)) pickOption(option);
      if (restart && quiz.contains(restart)) restartQuiz();
    });

    updateCounters();
    showStep(0);
  });
});
